import {DemoService} from 'app/core/services/demo.service';
import {AuthService, CurrentUser} from 'app/core/services/auth.service';
import {environment} from 'src/environments/environment';

type FacebookPixel = (command: string, eventName: string, options?: Record<string, any>) => void;

function init(fbq: FacebookPixel, user?: CurrentUser) {
    if (!environment.facebookPixelId) {
        return;
    }
    if (user) {
        fbq('init', environment.facebookPixelId as string, {
            external_id: user.id,
            extern_id: user.id,
        });
    } else {
        fbq('init', environment.facebookPixelId as string);
    }
    fbq('track', 'PageView');
}

export function FacebookPixelFactory(document: Document, demo: DemoService, auth: AuthService) {
    return async () => {
        // get pixel function from window object
        // defaultView is window or global this
        const fbq = (document.defaultView as any).fbq as FacebookPixel;
        if (!fbq) {
            return; // there's no connected pixel script @see analytics.js
        }
        if (demo.isDemoHost) {
            return init(fbq);
        }

        const user = await auth.init();
        return init(fbq, user);
    };
}
